import Breadcrumbs from '@v2/shared/components/Breadcrumbs';
import ContentCard from '@v2/shared/components/ContentCard';
import useUrlGenerator from '@v2/shared/lib/useUrlGenerator';
import Band from './Band';
import DoItYourself from './DoItYourself';
import LinkList from './LinkList';
import SectionCard from './SectionCard';
import StillNeedHelp from './StillNeedHelp';
import { CARD_GAP, EYEBROW, H2 } from './styles';
import { HelpCenterCategoryProps } from './types';

export default function HelpCategory({ props }: { props: HelpCenterCategoryProps }) {
  const { buildUrl } = useUrlGenerator();

  return (
    <>
      <Breadcrumbs items={props.breadcrumbs} />

      <Band
        title={props.category.title}
        intro={props.category.description}
        searchAction={props.searchAction}
        kustomer={props.kustomer}
        categoryTitles={props.categoryTitles}
      />

      <ContentCard className={CARD_GAP}>
        <p className={EYEBROW}>
          {props.category.count} article{props.category.count === 1 ? '' : 's'}
        </p>

        <ul className="m-0 list-none p-0">
          {props.articles.map((article) => (
            <li
              key={article.slug}
              className="m-0 border-0 border-t border-solid border-slate-200 py-4 first:border-t-0 first:pt-0"
            >
              <a
                href={buildUrl(article.href)}
                className="text-[17px] font-bold text-slate-900 no-underline hover:text-primary"
              >
                {article.title}
              </a>
              {article.summary ? <p className="mb-0 mt-1 text-sm text-slate-500">{article.summary}</p> : null}
            </li>
          ))}
        </ul>
      </ContentCard>

      <SectionCard>
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
          {props.otherCategories.length > 0 ? (
            <div>
              <h2 className={H2}>Other topics</h2>
              <LinkList links={props.otherCategories} />
            </div>
          ) : null}

          <DoItYourself />
        </div>
      </SectionCard>

      <StillNeedHelp />
    </>
  );
}
